// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"402":"13ffe681","467":"88c4e85c"}[chunkId] + ".chunk.js";
};